import DOMPurify from "dompurify";

// Strip anything that could execute script or leak data cross-origin.
// Admins own this content, so we're lenient on formatting (headings, lists,
// tables, links, inline images) but tight on scripts / event handlers / iframes.
const CONFIG = {
  ALLOWED_TAGS: [
    "p","br","hr","div","span","strong","em","b","i","u","s","del","mark","small","sup","sub",
    "h1","h2","h3","h4","h5","h6",
    "ul","ol","li",
    "a","img","figure","figcaption",
    "blockquote","code","pre",
    "table","thead","tbody","tr","td","th",
  ],
  ALLOWED_ATTR: ["href","title","target","rel","src","alt","width","height","style","class","colspan","rowspan"],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  FORBID_TAGS: ["script","iframe","object","embed","link","meta","style","form","input","button"],
  FORBID_ATTR: ["onerror","onload","onclick","onmouseover","onfocus","onblur","onchange","onsubmit","formaction","srcdoc"],
};

// Force target=_blank links to also carry rel="noopener noreferrer"
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

export function sanitizeHtml(dirty) {
  return DOMPurify.sanitize(dirty || "", CONFIG);
}
